// extracted by mini-css-extract-plugin
export default {"root-svg-filters":"divkit-dc22b"};